import React, {useEffect,useState} from 'react'
import axios from 'axios';

export default function FeedbackDashboard() {
    const [tags, setTags] = useState([])
    const [loading, setLoading] = useState(false)
    return (
        <div className="content-wrapper">

            <div className="overlay-wrapper" style={{ display: (loading?'':'none') }}>
                <div className="overlay"><i className="fas fa-3x fa-sync-alt fa-spin"></i><div className="text-bold pt-2"></div></div>
            </div>
            
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Feedback</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active">Feedback</li>
                        </ol>
                    </div>
                    </div>
                </div>


            </div>

            <section className="content">

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4">
                            <button type="button" className="btn btn-block btn-success btn-lg" onClick={()=>{return window.location="/feedback-records"}}>Feedback Records</button>
                            <button type="button" className="btn btn-block btn-info btn-lg" onClick={()=>{return window.location="/feedback-visuals"}}>Visualization</button>
                        </div>
                    </div>
                </div>
            </section>


            
        </div>
    )
}
